import styles from "./Post.module.css";
import { FC } from "react";
import { CardData } from "../../services/CardServices";
import Card from "../Cards/Card";
import Booster from "../Boosters/Booster";
import {
  FaHeart,
  FaComment,
  FaShare,
  FaBookmark,
  FaUser,
  FaEllipsis,
} from "react-icons/fa6";
import { Col, Row } from "react-bootstrap";
import { useFetchedUserPostsContext } from "../../context/fetchedUser/FetchedUserPostsProvider";
import InfiniteScroll from "../InfiniteScroll/InfiniteScroll";

const Post: FC = () => {
  const { postsState } = useFetchedUserPostsContext();

  return (
    <InfiniteScroll
      togglePage={postsState.togglePage}
      loading={postsState.loading}
      hasMore={postsState.hasMore}
    >
      {postsState.data.length > 0 ? (
        <div className={styles.container}>
          {postsState.data.map((post) => (
            <div className={styles.postContainer}>
              <div className={styles.headerContainer}>
                <div>
                  <FaUser size={30} />
                  username {post.created_at.toString()}
                </div>
                <FaEllipsis size={30} />
              </div>
              <div className={styles.imagePreview}>
                <div className={styles.mainImage}>
                  {post.boosters[0] ? (
                    <Booster
                      booster={post.boosters[0]}
                      // disableHover={true}
                      isInStore={true}
                    />
                  ) : (
                    post.cards[0] && (
                      <Card
                        cardData={post.cards[0]}
                        key={post.cards[0].id}
                        disableClick={true}
                      />
                    )
                  )}
                </div>
                <div className={styles.carouselContainer}>
                  {post.cards &&
                    post.cards.map((card: CardData) => (
                      <div className={styles.carouselImage}>
                        <Card cardData={card} key={card.id} />
                      </div>
                    ))}
                </div>
              </div>
              <div className={styles.buttonsContainer}>
                <Row>
                  <Col className={styles.actionButtons}>
                    <FaHeart size={30} className={styles.iconButton} />
                    <FaComment size={30} /> <FaShare size={30} />
                  </Col>
                  <Col xs={6}>
                    <div className={styles.buyButton}>
                      Get this booster for {post.boosters[0].price}€
                    </div>
                  </Col>
                  <Col className={styles.bookMarkButton}>
                    <FaBookmark size={30} />
                  </Col>
                </Row>
              </div>
              {post.content}
            </div>
          ))}{" "}
        </div>
      ) : (
        <h2 className={styles.center}>No Content</h2>
      )}
    </InfiniteScroll>
  );
};

export default Post;
